<script setup>
import { computed } from 'vue';
import { AI_NAME } from 'dashboard/helper/aiIdentity';

const props = defineProps({
  variant: {
    type: String,
    default: 'welcome',
    validator: value =>
      ['welcome', 'reading', 'cooking', 'thinking', 'writing'].includes(value),
  },
  decorative: { type: Boolean, default: true },
  description: { type: String, default: AI_NAME },
});

const illustrationSrc = computed(
  () => `/brand-assets/lia/${props.variant}.svg`
);
</script>

<template>
  <img
    :src="illustrationSrc"
    :alt="decorative ? '' : description"
    :aria-hidden="decorative || undefined"
    draggable="false"
    class="lia-illustration block w-full h-full object-contain"
    loading="lazy"
    decoding="async"
    width="320"
    height="280"
  />
</template>

<style scoped>
/* An embedded SVG inherits this color scheme, including manual theme changes. */
.lia-illustration {
  color-scheme: light;
}
.dark .lia-illustration {
  color-scheme: dark;
}
</style>
